import React from 'react';
import YearlyBarChart from './YearlyBarChart';
import MonthlyBoxplot from './MonthlyBoxplot';
import MonthlyLineChart from './MonthlyLineChart';
import MonthlyHeatmapChart from './MonthlyHeatmapChart';

const TimeDistribution = (props) => {
    return (
      <div class="container">
        <h3>Yearly Anthrax cases Bar Chart</h3>
        <YearlyBarChart />
        <br />
        <br />
        <br />
        <h3>Monthly Anthrax Cases Boxplot</h3>
        <MonthlyBoxplot />
        <br />
        <br />
        <br />
        <h3>Monthly Anthrax Cases Line Chart</h3>
        <MonthlyLineChart />
        <br />
        <br />
        <br />
        <h3>Monthly Anthrax Cases Heatmap</h3>
        <MonthlyHeatmapChart />
      </div>
  );
}

export default TimeDistribution;